import axios from 'axios';

class GuestService {
    static loginGuest = (body) => axios.post('/guest/login', body);

    static getPublicWeddingInfo = (weddingId) => axios.get(`/guest/wedding-public-info/${weddingId}`);

    static getWeddingDetailsForGuest = (weddingId) => axios.get(`/guest/wedding-details/${weddingId}`);

    static getLoggedGuest = () => axios.get('/guest/get-logged-guest');

    static confirmAttendance = (body) => axios.post('/guest/confirm-attendance', body);

    static searchGuests = (weddingId, query) => axios.get(`/guest/search/${weddingId}?q=${query}`);

    static reserveSeat = (body) => axios.post('/guest/reserve-seat', body);

    static cancelReservation = (body) => axios.post('/guest/cancel-reservation', body);

    static cancelGroup = (body) => axios.post('/guest/cancel-group', body);

    static confirmFamilyAttendance = (body) => axios.post('/guest/confirm-family-attendance', body);

    static reserveFamilyTable = (body) => axios.post('/guest/reserve-family-table', body);

    static cancelFamilyReservation = (body) => axios.post('/guest/cancel-family-reservation', body);
}

export default GuestService;
